/**
 * Popup di scelta dopo "Aggiungi al carrello" (elettrodomestici con consegna al piano).
 *
 * Perche' esiste (16/09/2026): con la consegna al piano preselezionata in scheda,
 * al checkout restava SOLO quella tariffa e chi voleva il ritiro in sede non
 * trovava piu' l'opzione (abbandono 67% contro 49%). Qui, prima del carrello, il
 * cliente vede le tre consegne con i prezzi veri dell'API, i servizi e la garanzia.
 *
 * Regole decise con Danilo:
 *  - la consegna al piano resta proposta (stato di partenza = blocco in scheda),
 *    ma consegna standard e ritiro in sede stanno nello stesso blocco;
 *  - i servizi restano visibili ma spenti se la consegna al piano non e' scelta;
 *  - "Decido dopo" aggiunge SOLO il prodotto: niente al piano, servizi o garanzia.
 *
 * Viene aperto da product-services-selector.js (window.__atcPopup.open) che gli
 * passa dati API, stato e le funzioni che costruiscono le righe servizio. La
 * garanzia arriva da window.__warrantyConfig (warranty-upsell.liquid), che su
 * queste schede non apre piu' il suo popup: il submit lo prende prima il selettore.
 */
(function () {
  'use strict';
  if (window.__atcPopup) return;

  var ALP_SHIPPING_ID = 39;
  var PICKUP_SHIPPING_ID = 31;
  var ALP_MARKER_VARIANT = Number((window.__svcVariants || {}).ALP || 65719443161437); // riga-marcatore "Consegna al piano" nel carrello
  var MOBILE_BP = 750;

  var wconf = window.__warrantyConfig || {};
  var tiers = (wconf.tiers || []).slice().sort(function (a, b) { return a.max_price - b.max_price; });

  function fmtEuro(n) {
    if (n == null || isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function cleanName(name) {
    return String(name || '').replace(/^consegna con servizio al piano$/i, 'Consegna al piano').replace(/\s+/g, ' ').trim();
  }
  function findTier(price) {
    for (var i = 0; i < tiers.length; i++) if (price <= tiers[i].max_price) return tiers[i];
    return null;
  }
  function productPrice() {
    var p = parseFloat(window.__warrantyProductPrice);
    return isNaN(p) ? 0 : p;
  }

  var ICON = {
    piano: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-8 9 8"></path><path d="M5 10v10h14V10"></path><path d="M10 20v-6h4v6"></path></svg>',
    standard: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2z"></path><path d="M13 9h4l3 3v4h-7"></path><circle cx="6" cy="18" r="1.8"></circle><circle cx="16.5" cy="18" r="1.8"></circle></svg>',
    ritiro: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 10l1.5-5h15L21 10"></path><path d="M4 10v10h16V10"></path><path d="M10 20v-5h4v5"></path></svg>',
    ok: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"></path></svg>',
    okgreen: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0b7a3b" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"></path></svg>',
    x: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"></path></svg>'
  };

  // --- DOM ---------------------------------------------------------------
  var overlay = document.createElement('div');
  overlay.className = 'acp-overlay';
  overlay.innerHTML =
    '<div class="acp-backdrop"></div>' +
    '<div class="acp-panel" role="dialog" aria-modal="true" aria-label="Consegna, servizi e garanzia">' +
      '<button type="button" class="acp-x" data-acp-close aria-label="Chiudi">' + ICON.x + '</button>' +
      '<div class="acp-handle"><span></span></div>' +
      '<div class="acp-scroll">' +
        '<div class="acp-head" data-acp-head></div>' +
        '<section class="acp-sec"><p class="acp-h">1 &middot; Come vuoi riceverla?</p>' +
          '<p class="acp-note" data-acp-alp-note></p>' +
          '<p class="acp-warn" data-acp-cart-alp hidden>Nel carrello hai gi&agrave; la consegna al piano: vale per tutto l&#39;ordine.</p>' +
          '<div class="acp-list" data-acp-ship></div></section>' +
        '<section class="acp-sec" data-acp-svc-sec><p class="acp-h">2 &middot; Servizi <span class="acp-off-msg" data-acp-off hidden></span></p>' +
          '<div class="acp-list" data-acp-svc></div></section>' +
        '<section class="acp-sec" data-acp-w-sec hidden><p class="acp-h">3 &middot; Garanzia</p>' +
          '<div class="acp-list" data-acp-w></div></section>' +
      '</div>' +
      '<div class="acp-foot">' +
        '<div class="acp-total"><span>Consegna e servizi scelti</span><b data-acp-total></b></div>' +
        '<button type="button" class="acp-cta" data-acp-go>Continua</button>' +
        '<button type="button" class="acp-later" data-acp-later>Decido dopo, vai al carrello</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  // il banner cookie arriva tardi: a pagina scarica lo scavalco una volta, in idle,
  // cosi' al primo tap non serve nessuno spostamento
  var ultimoInFondo = function () { if (overlay.nextElementSibling) document.body.appendChild(overlay); };
  if ('requestIdleCallback' in window) requestIdleCallback(ultimoInFondo, { timeout: 5000 }); else setTimeout(ultimoInFondo, 3000);

  var panel = overlay.querySelector('.acp-panel');
  var $ = function (sel) { return overlay.querySelector(sel); };

  var ctx = null;       // dati passati dal selettore all'apertura
  var sel = null;       // stato corrente: { ship, addons: {}, warranty }
  var tier = null;
  var busy = false;

  // Misura per il controllo orario su PostHog: senza questi eventi il popup e' cieco
  function track(nome, props) {
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(nome, props || {}); } catch (e) {}
  }
  function sceltaProps() {
    return {
      consegna: sel.ship === ALP_SHIPPING_ID ? 'al_piano' : (sel.ship === 31 ? 'ritiro' : 'standard'),
      servizi: Object.keys(sel.addons).filter(function (k) { return sel.addons[k]; }).join(','),
      garanzia: !!sel.warranty,
      quantita: ctx.qty || 1
    };
  }

  function open(c) { ctx = c;
    tier = null;
    if (tiers.length && productPrice() > 0) tier = findTier(productPrice());

    // stato di partenza dal blocco in scheda: al piano se era acceso, altrimenti
    // la prima consegna diversa dall'al piano
    var list = (ctx.shippingList || []).filter(function (o) { return o && o.name; });
    if (!list.length && ctx.alp) list = [{ id: ALP_SHIPPING_ID, name: ctx.alp.name, price: ctx.alp.price }];
    var defaultShip = ctx.state.alp ? ALP_SHIPPING_ID : (list.filter(function (o) { return o.id !== ALP_SHIPPING_ID; })[0] || list[0] || {}).id;
    sel = { ship: defaultShip, addons: Object.assign({}, ctx.state.addons), warranty: false };
    if (sel.ship !== ALP_SHIPPING_ID) Object.keys(sel.addons).forEach(function (k) { sel.addons[k] = false; }); renderHead(); renderShip(list); renderServices(); renderWarranty(); update();

    // a pari z-index vince chi sta dopo nel DOM: il banner cookie arriva tardi, quindi
    // a ogni apertura rimetto il popup in fondo al body, sopra di lui
    // Riappendere il nodo a ogni apertura costava 35-45 ms su desktop (ricalcolo
    // del layout di tutta la pagina), 300-400 ms su Android: era la voce piu'
    // grossa dell'INP sul tap "Aggiungi al carrello" (inp_attribution, 22/09).
    // Si sposta solo se nel frattempo qualcosa e' finito dopo di lui.
    if (overlay.nextElementSibling) document.body.appendChild(overlay);
    panel.style.transform = '';
    overlay.classList.add('acp-open');
    document.body.style.overflow = 'hidden';
    track('ATC Popup Opened', { consegna_proposta: sel.ship === ALP_SHIPPING_ID ? 'al_piano' : 'altro', garanzia_offerta: !!tier });
    setTimeout(function () { var f = $('[data-acp-go]'); if (f) f.focus(); }, 60);

    // La consegna vale per tutto l'ordine: se un altro prodotto ha gia' l'al piano
    // in carrello, lo dico e lo propongo anche qui, cosi' la scelta e' coerente.
    $('[data-acp-cart-alp]').hidden = true;
    var f = ctx.fetch || window.__warrantyOrigFetch || window.fetch;
    var mioCtx = ctx;
    f('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (ctx !== mioCtx || !overlay.classList.contains('acp-open')) return;
        var giaAlPiano = (cart.items || []).some(function (i) { return Number(i.variant_id) === ALP_MARKER_VARIANT; });
        if (!giaAlPiano) return;
        $('[data-acp-cart-alp]').hidden = false;
        if (sel.ship !== ALP_SHIPPING_ID && list.some(function (o) { return o.id === ALP_SHIPPING_ID; })) {
          sel.ship = ALP_SHIPPING_ID;
          renderShip(list);
          renderServices();
          update();
        }
      })
      .catch(function () {});
  }

  function close() {
    overlay.classList.remove('acp-open');
    document.body.style.overflow = '';
  }

  function renderHead() {
    var title = document.querySelector('.product__title, .product__info h1, h1');
    var img = document.querySelector('.product__media img, media-gallery img');
    $('[data-acp-head]').innerHTML =
      (img && img.currentSrc ? '<img class="acp-thumb" src="' + esc(img.currentSrc) + '" alt="">' : '<span class="acp-thumb"></span>') +
      '<div class="acp-head__txt">' +
        '<span class="acp-added">' + ICON.okgreen + ' Aggiunto al carrello</span>' +
        '<span class="acp-title">' + esc(title ? title.textContent.trim() : '') + '</span>' +
        (ctx.qty > 1 ? '<span class="acp-qty">Quantità: ' + ctx.qty + '</span>' : '') +
      '</div>';
  }

  function optionRow(kind, on, iconKey, name, desc, price, attrs, badge) {
    return '<button type="button" class="acp-opt' + (on ? ' is-on' : '') + '" ' + attrs + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="acp-' + kind + (on ? ' is-on' : '') + '">' + (kind === 'check' && on ? ICON.ok : '') + '</span>' +
      (iconKey ? '<span class="acp-ic">' + ICON[iconKey] + '</span>' : '') +
      '<span class="acp-opt__main"><span class="acp-opt__name">' + esc(name) + (badge ? ' <span class="acp-badge">' + esc(badge) + '</span>' : '') + '</span>' +
      (desc ? '<span class="acp-opt__desc">' + desc + '</span>' : '') + '</span>' +
      '<span class="acp-opt__price">' + esc(price) + '</span>' +
    '</button>';
  }

  function renderShip(list) {
    var html = list.map(function (o) {
      var isAlp = o.id === ALP_SHIPPING_ID;
      var icon = isAlp ? 'piano' : (o.id === PICKUP_SHIPPING_ID ? 'ritiro' : 'standard');
      var desc = '';
      var name = cleanName(o.name);
      if (isAlp) desc = 'Contatto telefonico e disimballo';
      // il corriere lo chiamiamo col nostro nome, non con quello del listino
      if (!isAlp && o.id !== PICKUP_SHIPPING_ID) { name = 'Consegna standard'; desc = 'Su appuntamento telefonico'; }
      if (o.id === PICKUP_SHIPPING_ID) { name = 'Ritiro in sede'; desc = 'Paderno Dugnano (MI)'; }
      return optionRow('radio', sel.ship === o.id, icon, name, desc, o.price != null ? fmtEuro(o.price) : '', 'data-acp-ship-id="' + o.id + '"');
    }).join('');
    $('[data-acp-ship]').innerHTML = html;
    var note = $('[data-acp-alp-note]');
    var zipNote = ctx.zip ? 'Prezzi per il CAP ' + ctx.zip : 'Prezzi indicativi per Milano';
    note.textContent = zipNote + '.';

    Array.prototype.forEach.call($('[data-acp-ship]').querySelectorAll('[data-acp-ship-id]'), function (b) {
      b.addEventListener('click', function () {
        sel.ship = parseInt(b.getAttribute('data-acp-ship-id'), 10);
        if (sel.ship !== ALP_SHIPPING_ID) Object.keys(sel.addons).forEach(function (k) { sel.addons[k] = false; });
        renderShip(list);
        renderServices();
        update();
      });
    });
  }

  function renderServices() {
    var addons = (ctx.alp && ctx.alp.addons) || [];
    var alpOn = sel.ship === ALP_SHIPPING_ID;
    var secEl = $('[data-acp-svc-sec]');
    if (!addons.length) { secEl.hidden = true; return; }
    secEl.hidden = false;
    var off = $('[data-acp-off]');
    off.hidden = alpOn;
    off.textContent = 'solo con la consegna al piano';
    var listEl = $('[data-acp-svc]');
    listEl.classList.toggle('is-off', !alpOn);
    listEl.innerHTML = addons.map(function (a, i) {
      var desc = a.qualifier || '';
      if (i === ctx.kcIdx && ctx.instIdx !== -1) desc = 'Disponibile solo con l’installazione';
      var price = a.price ? '+ ' + fmtEuro(a.price * (ctx.qty || 1)) : 'Gratis';
      return optionRow('check', !!sel.addons[i], null, a.name, esc(desc), price, 'data-acp-svc-i="' + i + '"' + (alpOn ? '' : ' disabled'));
    }).join('');
    Array.prototype.forEach.call(listEl.querySelectorAll('[data-acp-svc-i]'), function (b) {
      b.addEventListener('click', function () {
        if (sel.ship !== ALP_SHIPPING_ID) return;
        var i = parseInt(b.getAttribute('data-acp-svc-i'), 10);
        // colonna solo con installazione attiva; spenta l'installazione, via anche la colonna
        if (i === ctx.kcIdx && ctx.instIdx !== -1 && !sel.addons[ctx.instIdx] && !sel.addons[i]) return;
        sel.addons[i] = !sel.addons[i];
        if (i === ctx.instIdx && !sel.addons[i] && ctx.kcIdx !== -1) sel.addons[ctx.kcIdx] = false;
        renderServices();
        update();
      });
    });
  }

  function renderWarranty() {
    var secEl = $('[data-acp-w-sec]');
    if (!tier) { secEl.hidden = true; return; }
    secEl.hidden = false;
    var dur = tier.duration || '3 anni';
    var desc = 'Massimale ' + fmtEuro(tier.max_price) + ', senza franchigia';
    // 2 anni di garanzia legale + quelli dell'estensione
    var anni = parseInt(dur, 10);
    var totale = isNaN(anni) ? '' : 'Totale ' + (anni + 2) + ' anni';
    $('[data-acp-w]').innerHTML = optionRow('check', sel.warranty, null, 'Garanzia estesa ' + dur + ((ctx.qty || 1) > 1 ? ' × ' + ctx.qty : ''), esc(desc), fmtEuro(tier.price * (ctx.qty || 1)), 'data-acp-w-toggle', totale);
    $('[data-acp-w-toggle]').addEventListener('click', function () {
      sel.warranty = !sel.warranty;
      renderWarranty();
      update();
    });
  }

  function total() {
    var sum = 0;
    var ship = (ctx.shippingList || []).filter(function (o) { return o.id === sel.ship; })[0];
    if (ship && ship.price) sum += ship.price;
    // servizi e garanzia seguono la quantita' del prodotto (come le righe in carrello)
    var q = ctx.qty || 1;
    if (sel.ship === ALP_SHIPPING_ID) (ctx.alp.addons || []).forEach(function (a, i) { if (sel.addons[i]) sum += (a.price || 0) * q; });
    if (sel.warranty && tier) sum += tier.price * q;
    return sum;
  }
  function update() {
    var t = total();
    $('[data-acp-total]').textContent = t > 0 ? fmtEuro(t) : '—';
  }

  // --- scritture carrello ---------------------------------------------------
  function goToCart() { window.location.href = '/cart'; }

  function submit(items, alpOn, withWarranty, chiudiSubito, scelta) {
    if (busy) return;
    busy = true;
    var go = $('[data-acp-go]');
    go.disabled = true; go.textContent = 'Aggiungo…';
    if (chiudiSubito) close();
    var f = ctx.fetch || window.__warrantyOrigFetch || window.fetch;
    f('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return ctx.updateAlpMarker ? ctx.updateAlpMarker(alpOn) : null; })
      .then(function () {
        // la Function delivery-alp legge questa scelta e mette in cima al checkout
        // il ritiro o il corriere; con "decido dopo" (scelta undefined) non tocco nulla
        if (scelta === undefined) return null;
        return f('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _consegna_scelta: scelta } }) })
          .catch(function () {});
      })
      .then(function () {
        if (withWarranty && tier && typeof window.__warrantyRegistraLegame === 'function') {
          return window.__warrantyRegistraLegame(ctx.parentItem.id, tier.variant_id);
        }
      })
      .then(goToCart)
      .catch(function (err) {
        track('ATC Popup Error', { messaggio: String(err && err.message || err) });
        // qualcosa e' andato storto: almeno il prodotto deve entrare in carrello
        f('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [ctx.parentItem] }) })
          .then(goToCart, goToCart);
      });
  }

  function onContinue() {
    if (busy) return;
    var alpOn = sel.ship === ALP_SHIPPING_ID;
    var items = [ctx.parentItem].concat(ctx.serviceItems(alpOn, sel.addons));
    if (sel.warranty && tier) items.push({ id: parseInt(tier.variant_id, 10), quantity: ctx.qty || 1 });
    track('ATC Popup Choice', Object.assign({ azione: 'continua' }, sceltaProps()));
    submit(items, alpOn, sel.warranty, false, alpOn ? '' : (sel.ship === 31 ? 'ritiro' : 'standard'));
  }
  function onLater() {
    // solo il prodotto, nessuna scelta fatta per il cliente; il popup si chiude subito
    if (busy) return;
    track('ATC Popup Choice', { azione: 'decido_dopo', quantita: ctx.qty || 1 });
    submit([ctx.parentItem], false, false, true);
  }

  $('[data-acp-go]').addEventListener('click', onContinue);
  $('[data-acp-later]').addEventListener('click', onLater);
  $('[data-acp-close]').addEventListener('click', onLater);
  // Il tema nasconde i div vuoti (div:empty{display:none}): lo sfondo scuro spariva e
  // il click "fuori" cadeva sull'overlay, dove non ascoltava nessuno. Ascolto li'.
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || (e.target.classList && e.target.classList.contains('acp-backdrop'))) onLater();
  });
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('acp-open')) { e.stopPropagation(); onLater(); }
  }, true);

  // Trascinamento verso il basso = "Decido dopo". Solo da linguetta e intestazione.
  // Pointer Events con cattura del puntatore, agganciati direttamente ai due elementi:
  // la versione a touch delegati sul pannello su iPhone non riconosceva il tocco
  // (QA 17/09). touch-action:none sui due elementi evita che Safari si prenda il gesto.
  function bindDrag(el) {
    if (!el) return;
    var startY = 0, curY = 0, active = false, pid = null;
    function fine(chiudi) {
      if (!active) return;
      active = false;
      panel.style.transition = '';
      try { el.releasePointerCapture(pid); } catch (err) {}
      var d = curY - startY;
      if (d > 70) onLater(); else panel.style.transform = '';
    }
    el.addEventListener('pointerdown', function (e) {
      if (window.innerWidth >= MOBILE_BP || busy) return;
      active = true; startY = curY = e.clientY; pid = e.pointerId;
      try { el.setPointerCapture(pid); } catch (err) {}
      panel.style.transition = 'none';
    });
    el.addEventListener('pointermove', function (e) {
      if (!active) return;
      curY = e.clientY;
      var d = curY - startY;
      if (d > 0) panel.style.transform = 'translateY(' + d + 'px)';
    });
    el.addEventListener('pointerup', function () { fine(true); });
    el.addEventListener('pointercancel', function () { fine(false); });
  }
  bindDrag(overlay.querySelector('.acp-handle'));
  bindDrag(overlay.querySelector('.acp-head'));

  // Il submit lo prendo io: questo script e' nella sezione prodotto e parte prima
  // di warranty-upsell.js, quindi il mio ascoltatore in cattura viene prima del suo.
  // Se il selettore non ha ancora i dati dell'API, lascio il flusso normale.
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
    if (!form || busy || overlay.classList.contains('acp-open')) return;
    var svc = window.__svcSelector;
    if (!svc || !svc.section || !svc.section.contains(form)) return;
    var c = svc.contextFor(form);
    if (!c) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    open(c);
  }, true);

  window.__atcPopup = { open: open, close: close };
})();
